<template>
    <div>
        <Info :productLibraryInfo="productLibraryInfo"></Info>
    </div>
</template>
<script>
import Info from './Info.vue'
export  default {
    components: {
        Info
    },
    data(){
        return {
            productLibraryInfo: this.$store.state.productInfo
        }
    }
}
</script>
